var React = require('react');

function OnsiteAccommodation (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.3337 9.16658V16.6666H16.667V14.1666H3.33366V16.6666H1.66699V3.33325H3.33366V11.6666H10.0003V5.83325H15.0003C15.8844 5.83325 16.7322 6.18444 17.3573 6.80956C17.9825 7.43468 18.3337 8.28253 18.3337 9.16658ZM6.66699 10.8333C6.00395 10.8333 5.36807 10.5699 4.89923 10.101C4.43038 9.63218 4.16699 8.99629 4.16699 8.33325C4.16699 7.67021 4.43038 7.03433 4.89923 6.56549C5.36807 6.09664 6.00395 5.83325 6.66699 5.83325C7.33003 5.83325 7.96592 6.09664 8.43476 6.56549C8.9036 7.03433 9.16699 7.67021 9.16699 8.33325C9.16699 8.99629 8.9036 9.63218 8.43476 10.101C7.96592 10.5699 7.33003 10.8333 6.66699 10.8333Z","fill":"#616466"}));
}

OnsiteAccommodation.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = OnsiteAccommodation;

OnsiteAccommodation.default = OnsiteAccommodation;
